module.exports = __webpack_public_path__ + "img/male_A_03.7f003cd6.png";